export { default } from './WistiaVideo';
